import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { FiltersProps } from "../../../../@types";

import { Button as Btn } from "primereact/button";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { Sidebar } from "primereact/sidebar";
import { SplitButton } from "primereact/splitbutton";
import {
	Accordion,
	Button,
	Card,
	Col,
	Container,
	Form,
	FormControl,
	InputGroup,
	OverlayTrigger,
	Row,
	Spinner,
	Tooltip,
} from "react-bootstrap";
import { toast } from "react-toastify";
import UsuarioContext from "../../../../../context/userContext/context";
import { Modal } from "../../../../components/modal";
import { PaginationList } from "../../../../components/pagination";
import { TreeTableProductsList } from "../../components/table-products";
import {
	DisabledButton,
	NotFound,
	ObjectsCategoryIcon,
	PrimaryButton,
} from "../../styled";
import { ModalImportProduct } from "../modal/import-product";
import { ModalWarningImportProduct } from "../modal/warning-import";
import {
	ActionRibbon,
	BatchActions,
	ContentBody,
	MultiSelectFilter,
} from "./styled";

import { FaEllipsisH, FaFolder } from "react-icons/fa";
import {
	MdAddCircleOutline,
	MdFilterList,
	MdInfoOutline,
	MdOutlineCollectionsBookmark,
	MdOutlineDelete,
	MdOutlineImportExport,
	MdOutlineViewColumn,
	MdSearch,
	MdStorefront,
} from "react-icons/md";

//services
import {
	listObjectType,
	listPartners,
	listProject,
} from "../../../../services/filters.service";
import {
	integrationImportMaterials,
	integrationScheduleUpdateImportMaterials,
	integrationUpdateImportMaterials,
} from "../../../../services/integration.service";
import {
	getSpredsheets,
	managerProduct,
	managerProductActivate,
	managerProductInactivate,
	managerProductLeaf,
	managerProductRemove,
	managerProductSelectAll,
	managerUpdatePrice,
	managerUpdatePriceBatch,
	productBatch,
	productDeleteBatch,
	productInativateBatch,
	productPublish,
	productPublishPlaceUpdate,
	productReactivateBatch,
	uploadSpredsheets,
} from "../../../../services/manager.service";
import { managerProfileDetails } from "../../../../services/profile.service";
import { ActionItemLink } from "../../components/action-item-link";
import { BatchActionPublishModal } from "./components/batch-action-modal";
import { BatchDeleteMaterialModal } from "./components/delete-batch-modal";
import { BatchInactivateMaterialModal } from "./components/inactivate-batch-modal";
import { SelectAllInfo } from "./components/select-all";

export interface ISelectedNode {
	id: number;
	children_selected: boolean;
	title?: string;
	category?: any;
	can_publish?: boolean;
	is_published_store?: any;
	is_published?: any;
	is_active?: any;
}

export const ProductManager = (): JSX.Element => {
	const history = useHistory();
	const { t: translation } = useTranslation();
	const { user } = useContext(UsuarioContext);

	const fileInputDiscipline = useRef<any>(null);
	const fileInputTheme = useRef<any>(null);

	const [selectedNode, setSelectedNode] = useState<any>();
	const [selectedFullNode, setSelectedFullNode] = useState<any>();
	const [actionSelected, setActionSelected] = useState<any>();

	const [filters, setFilters] = useState<FiltersProps>({});
	const [loading, setLoading] = useState<boolean>(false);
	const [loadingModalPlanilha, setLoadingModalPlanilha] =
		useState<boolean>(false);
	const [loadingModal, setLoadingModal] = useState<boolean>(false);
	const [disciplineSheet, setDisciplineSheet] = useState<any>(null);
	const [themeSheet, setThemeSheet] = useState<any>(null);

	// Material Type Filter
	const [materialType, setMaterialType] = useState<any>([]);
	const materialTypeItems = [
		{ label: translation("manager.type.discipline"), value: "Discipline" },
		{ label: translation("manager.type.object"), value: "Media" },
		{ label: translation("manager.type.theme"), value: "Theme" },
		{ label: translation("manager.type.unity"), value: "Item" },
	];

	// Material Type Filter
	const [materialPublishPlace, setMaterialPublishPlace] = useState<any>([]);
	const materialPublishPlaceItems = [
		{ label: translation("manager.place.location"), value: "location" },
		{ label: translation("manager.place.store"), value: "store" },
	];

	//Object Category Filter
	const [categoriesItems, setCategoryItems] = useState<any>([]);
	const [category, setCategory] = useState<any>([]);

	// Modalities filter (nível de formação)
	const modalities = [
		{ label: "Graduação", value: 1 },
		{ label: "Pós-Graduação", value: 2 },
		// { label: "Livre", value: 3 },
		{ label: "Técnico", value: 4 },
	];

	//Indicator Filter
	const [indicatorsFilterItems] = useState<any>([
		{ title: "Contém material não publicado", id: "unpublished" },
		{ title: "Contém material publicado", id: "published" },
		{ title: "Contém objeto incompleto", id: "complete" },
		{ title: "Material não vinculados", id: "no_bond" },
		{ title: "Material sem projeto vinculado", id: "no_project" },
	]);

	const [indicatorsFilter, setIndicatorsFilter] = useState<any>([]);
	const [columns, setColumns] = useState<any>([
		{ field: "code", header: "Código" },
		{ field: "product_origin", header: "Origem" },
		{ field: "responsible", header: "Parceiro" },
		{ field: "status", header: "Status" },
		{ field: "type_name", header: "Tipo" },
	]);

	const [treeTableConfig, setTreeTableConfig] = useState<any>([
		{
			field: "title",
			header: "Nome",
			className: "sm-text",
			nameTemplate: true,
			expander: true,
			sortable: true,
			style: { textAlign: "left", width: "35%" },
		},
		{
			field: "type_name",
			className: "d-none d-sm-table-cell",
			header: "Tipo",
			sortable: false,
			style: { textAlign: "center" },
		},
		{
			field: "responsible",
			className: "d-none d-sm-table-cell",
			partnerTemplate: true,
			header: "Parceiro",
			sortable: false,
			style: { textAlign: "center" },
		},
		{
			field: "code",
			className: "d-none d-sm-table-cell",
			header: "Código",
			sortable: true,
			style: {
				textAlign: "center",
				overflow: "hidden",
				textOverflow: "ellipsis",
				maxWidth: 150,
			},
		},
		{
			field: "product_origin",
			className: "d-none d-sm-table-cell",
			header: "Origem",
			sortable: true,
			style: { textAlign: "center" },
		},
	]);

	// Deadline Filter
	const [deadlineFilterItems] = useState<any>([
		{ title: "Pronta Entrega", id: 1 },
		{ title: "20 dias", id: 2 },
	]);

	const [deadlineFilter, setDeadlineFilter] = useState<any>([]);

	// Project Filter
	const [projectFilterItems, setProjectFilterItems] = useState<any>([]);
	const [projectFilter, setProjectFilter] = useState<any>([]);

	//Object Category Filter
	const [partnersOptions, setPartnersOptions] = useState<any>([]);
	const [partnersSelected, setPartnersSelected] = useState<any>([]);

	// Modal
	const [showImportModal, setImportModal] = useState<boolean>(false);
	const [showConfigImportModal, setConfigImportModal] =
		useState<boolean>(false);
	const [isIntegrationConfig, setIsIntegrationConfig] =
		useState<boolean>(false);
	const [showInactivateModalConfirm, setInactivateModalConfirm] =
		useState<boolean>(false);
	const [showDeleteModalConfirm, setDeleteModalConfirm] =
		useState<boolean>(false);
	const [showUnpublishModalConfirm, setUnpublishModalConfirm] =
		useState<boolean>(false);
	const [showAddSpreadsheetModal, setShowAddSpreadsheetModal] =
		useState<boolean>(false);
	const [showSchedulingImportModal, setshowSchedulingImportModal] =
		useState<boolean>(false);
	const [showPublishedOptionsModal, setShowPublishedOptionsModal] =
		useState<boolean>(false);
	const [showBatchPublishModal, setShowBatchPublishModal] = useState(false);

	const [showInativateMaterialModal, setShowInativateMaterialModal] =
		useState<boolean>(false);
	const [showDeleteMaterialModal, setShowDeleteMaterialModal] =
		useState<boolean>(false);

	// Importing
	const [isImporting, setIsImporting] = useState<boolean>(false);

	//Pagination
	const [totalItens, setTotalItens] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);

	//Ordering
	const [sortOrder, setSortOrder] = useState();
	const [sortField, setSortField] = useState();
	const [isSorting, setIsSorting] = useState(false);

	//Selection
	const [disciplines, setDisciplines] = useState<ISelectedNode[]>([]);
	const [items, setItems] = useState<ISelectedNode[]>([]);
	const [objects, setObjects] = useState<number[]>([]);
	const [objectsComposed, setObjectsComposed] = useState<ISelectedNode[]>([]);
	const [perPageSelectedMaterial, setPerPageSelectedMaterial] = useState<{
		[key: number]: number;
	}>({ 1: 0 });
	const [noReasonMaterial, setNoReasonMaterial] = useState<number>(0);
	const [batchAction, setBatchAction] = useState<number>(0);
	const [batchToLocation, setBatchToLocation] = useState(false);
	const [batchToStore, setBatchToStore] = useState(false);
	const [allSelected, setAllSelected] = useState(false);

	const [query, setQuery] = useState("");
	const [viewTableTypeValue, setViewTableTypeValue] = useState("manager");
	const [locationList, setLocationList] = useState<any[]>([]);
	const [showEmptyMessage, setShowEmptyMessage] = useState<boolean>(false);
	const [showSearchBar, setShowSearchBar] = useState<boolean>(false);
	const [showFilterSidebar, setShowFilterSidebar] = useState<boolean>(false);
	const [clearFilters, setClearFilters] = useState<boolean>(false);
	const [checkboxIsLocation, setCheckboxIsLocation] =
		useState<boolean>(false);
	const [checkboxIsStore, setCheckboxIsStore] = useState<boolean>(false);
	const [checkAllType, setCheckAllType] = useState<null>();

	const handleChangeCheckAllType = (value: any) => {
		if (value) {
			setCheckAllType(value);
			handleOnChange(value, "check_type");
		}
	};

	const handleClearSlection = () => {
		setDisciplines([]);
		setItems([]);
		setObjects([]);
		setPerPageSelectedMaterial({});
		setAllSelected(false);
	};

	// calcular o número de materiais que podem ser publicados com base na resposta de materials_list/
	const getNoReasonCount = (data: any): number => {
		return data.results.length;
		// return (
		// 	data.results.filter((item: any) => item.data.reason === "")
		// 		.length ?? 0
		// );
	};

	const handleTableSort = useCallback(
		(event: any) => {
			let order =
				event.sortOrder < 0 ? "-" + event.sortField : event.sortField;

			setSortOrder(event.sortOrder);
			setSortField(event.sortField);

			setFilters({ ...filters, page: currentPage, ordering: order });
		},
		[filters],
	);

	const handleFilters = (event?: any) => {
		setFilters({ ...event, page: 1 });
	};

	const handlePageChange = (event?: any) => {
		window.scrollTo(0, 0);
		setFilters({ ...filters, page: event });
		setCurrentPage(event);
	};

	const handleConfirmProductUnpublish = () => {
		setLoadingModal(true);
		if (selectedNode.typeCheck === "location") {
			let obj = {
				is_location: false,
				material_id: selectedNode.id,
				material_type: selectedNode.type.toLowerCase(),
			};
			productPublishPlaceUpdate(obj)
				.then((response: any) => {
					handleUpdateList(
						response,
						"Material despublicado com sucesso!",
					);
					setLoadingModal(false);
				})
				.catch(() => {
					toast.error("Erro ao despublicar o material!");
					setUnpublishModalConfirm(false);
					setLoadingModal(false);
				});
		} else if (selectedNode.typeCheck === "store") {
			let obj = {
				is_store: false,
				material_id: selectedNode.id,
				material_type: selectedNode.type.toLowerCase(),
			};
			productPublishPlaceUpdate(obj)
				.then((response: any) => {
					handleUpdateList(
						response,
						"Material despublicado com sucesso!",
					);
					setLoadingModal(false);
				})
				.catch(() => {
					toast.error("Erro ao despublicar o material!");
					setUnpublishModalConfirm(false);
					setLoadingModal(false);
				});
		}
	};

	const handleProductPublish = (
		node: any,
		canPublishLocation: boolean,
		canPublishStore: boolean,
	) => {
		if (!canPublishLocation && !canPublishStore) {
			toast.warning(
				"Não foi possível publicar o material. Verifique as pendências que estão sendo indicadas na tabela antes de publicar um material",
			);
			return;
		}
		setSelectedNode(node.data);
		setShowPublishedOptionsModal(true);
	};

	const handleConfirmPublishOptions = () => {
		setLoadingModal(true);

		function updateAndPublish(is_location: boolean, is_store: boolean) {
			let obj = {
				is_location: is_location,
				is_store: is_store,
				material_id: selectedNode.id,
				material_type: selectedNode.type.toLowerCase(),
			};

			productPublishPlaceUpdate(obj)
				.then(() => {
					productPublish(
						selectedNode.id,
						selectedNode.type,
						checkboxIsLocation,
						checkboxIsStore,
					)
						.then((resp: any) => {
							let msg = "";
							if (
								(selectedNode.is_published === false &&
									selectedNode.is_published !==
										checkboxIsLocation) ||
								(selectedNode.is_published_store === false &&
									selectedNode.is_published_store !==
										checkboxIsStore)
							) {
								msg = "Material publicado com sucesso!";
							} else {
								msg = "Material despublicado com sucesso!";
							}
							handleUpdateList(resp, msg);
							setLoadingModal(false);
							setShowPublishedOptionsModal(false);
						})
						.catch((error: any) => {
							toast.error(error.response.data.message);
							setLoadingModal(false);
							setShowPublishedOptionsModal(false);
						});
				})
				.catch(() => {
					toast.error(
						"Ocorreu um erro ao atualizar este material. Tente novamente em alguns instantes.",
					);
					setLoadingModal(false);
				});
		}

		function justPublish() {
			productPublish(
				selectedNode.id,
				selectedNode.type,
				checkboxIsLocation,
				checkboxIsStore,
			)
				.then((resp: any) => {
					let msg = "";
					if (
						(selectedNode.is_published === false &&
							selectedNode.is_published !== checkboxIsLocation) ||
						(selectedNode.is_published_store === false &&
							selectedNode.is_published_store !== checkboxIsStore)
					) {
						msg = "Material publicado com sucesso!";
					} else {
						msg = "Material despublicado com sucesso!";
					}
					handleUpdateList(resp, msg);
					setLoadingModal(false);
					setShowPublishedOptionsModal(false);
				})
				.catch((error: any) => {
					toast.error(error.response.data.message);
					setLoadingModal(false);
					setShowPublishedOptionsModal(false);
				});
		}

		if (selectedNode.is_published && selectedNode.is_published_store) {
			// publicado nos dois
			justPublish();
		} else if (
			selectedNode.is_published &&
			!selectedNode.is_published_store
		) {
			//publicado na locacao
			if (selectedNode.price !== null) {
				if (!checkboxIsStore) {
					justPublish();
				} else {
					updateAndPublish(true, true);
				}
			} else {
				justPublish();
			}
		} else if (
			!selectedNode.is_published &&
			selectedNode.is_published_store
		) {
			//publicado na loja
			if (!checkboxIsLocation) {
				justPublish();
			} else {
				updateAndPublish(true, true);
			}
		} else {
			//nenhum publicado
			if (selectedNode.price !== null) {
				if (checkboxIsLocation && checkboxIsStore) {
					updateAndPublish(true, true);
				} else if (!checkboxIsLocation && checkboxIsStore) {
					if (selectedNode.is_location) {
						updateAndPublish(true, true);
					} else {
						updateAndPublish(false, true);
					}
				} else if (checkboxIsLocation && !checkboxIsStore) {
					if (selectedNode.is_store) {
						updateAndPublish(true, true);
					} else {
						updateAndPublish(true, false);
					}
				} else {
					toast.warning(
						"Selecione pelo menos uma das ações para continuar",
					);
					setLoadingModal(false);
					return;
				}
			} else {
				updateAndPublish(
					checkboxIsLocation
						? checkboxIsLocation
						: selectedNode.is_location,
					selectedNode.is_store,
				);
			}
		}
	};

	const handleUpdateList = (
		resp: any,
		message: string,
		showMessage = true,
	) => {
		setLoading(true);
		managerProduct(filters)
			.then((data) => {
				setNoReasonMaterial(getNoReasonCount(data));

				if (data.results.length === 0) {
					setShowEmptyMessage(true);
				} else {
					setShowEmptyMessage(false);
				}
				setLocationList(loadNodes(data.results));
				if (showMessage) {
					toast.success(message);
				}
				setUnpublishModalConfirm(false);
				setLoading(false);
			})
			.catch(() => {
				setLoading(false);
				setUnpublishModalConfirm(false);
			});
	};

	const handleImportModal = () => {
		if (isIntegrationConfig) {
			setImportModal(true);
		} else {
			setConfigImportModal(true);
		}
	};

	const handleImport = (payload: any) => {
		setIsImporting(true);
		integrationImportMaterials(payload)
			.then((resp) => {
				handleUpdateList(resp, "Materiais importados com sucesso!");
				setIsImporting(false);
				setImportModal(false);
			})
			.then(() => {
				setIsImporting(false);
			});
	};

	const handleOnChange = (event: any, field: any) => {
		let filter: any = filters;

		if (field === "q") {
			filter[field] = event;
			filter.page = 1;
		} else if (field === "modalities") {
			filter[field] = event.value;
			// setMaterialType(event.value);
		} else if (field === "product_type") {
			filter[field] = event.value;
			setMaterialType(event.value);
		} else if (field === "category_type") {
			filter[field] = event.value;
			setCategory(event.value);
		} else if (field === "deadlines") {
			filter[field] = event.value;
			setDeadlineFilter(event.value);
		} else if (field === "partners") {
			filter[field] = event.value;
			setPartnersSelected(event.value);
		} else if (field === "project") {
			filter[field] = event.value;
			setProjectFilter(event.value);
		} else if (field === "product_publish_place") {
			filter[field] = event.value;
			setMaterialPublishPlace(event.value);
		} else if (field === "check_type") {
			filter[field] = event;
		} else if (field === "indicators") {
			if (event.value.length === 0) {
				let obj = {
					q: filter.q,
					page: filter.page,
				};

				filter = obj;
			} else {
				if (filter.published) {
					delete filter["published"];
				}

				if (filter.complete) {
					delete filter["complete"];
				}

				if (filter.no_bond) {
					delete filter["no_bond"];
				}

				if (
					event.value.includes("unpublished") &&
					event.value.includes("published")
				) {
					delete filter["published"];
					event.value.forEach((value: any) => {
						if (value === "complete") {
							filter["complete"] = false;
						} else if (value === "no_bond") {
							filter["no_bond"] = true;
						}
					});
				} else {
					event.value.forEach((value: any) => {
						if (value === "unpublished") {
							filter["published"] = false;
						} else if (value === "published") {
							filter["published"] = true;
						} else if (value === "complete") {
							filter["complete"] = false;
						} else if (value === "no_bond") {
							filter["no_bond"] = true;
						}
					});
				}
			}

			setIndicatorsFilter(event.value);
		}

		handleFilters(filter);
	};

	/**
	 * Inicialização
	 */
	useEffect(() => {
		setLoading(true);

		listObjectType().then((data) => setCategoryItems(data));
		listProject().then((data) => setProjectFilterItems(data));

		if (user.is_superuser) {
			listPartners().then((data) => setPartnersOptions(data));
		}

		managerProduct()
			.then((data) => {
				if (data.results.length === 0) {
					setShowEmptyMessage(true);
				} else {
					setShowEmptyMessage(false);
				}
				setLocationList(loadNodes(data.results));
				setTotalItens(data.count);

				setNoReasonMaterial(getNoReasonCount(data));

				setLoading(false);
			})
			.catch(() => setLoading(false));

		if (!user.is_token_config) {
			managerProfileDetails(user.id).then((resp) => {
				setIsIntegrationConfig(resp.is_token_config);
			});
		} else {
			setIsIntegrationConfig(user.is_token_config);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (showAddSpreadsheetModal) {
			setLoadingModalPlanilha(true);
			getSpredsheets()
				.then((item) => {
					item.forEach((sheet: any) => {
						if (sheet.material_type === "Disciplina") {
							setDisciplineSheet({ name: sheet.title });
						}

						if (sheet.material_type === "Tema") {
							setThemeSheet({ name: sheet.title });
						}
					});
				})
				.finally(() => {
					setLoadingModalPlanilha(false);
				});
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showAddSpreadsheetModal]);

	useEffect(() => {
		filtersChanged();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentPage, sortOrder, sortField]);

	useEffect(() => {
		if (selectedNode) {
			setCheckboxIsLocation(selectedNode.is_location);
			setCheckboxIsStore(selectedNode.is_store);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedNode]);

	const filtersChanged = () => {
		if (filters && filters.page && !isSorting) {
			setIsSorting(true);
			managerProduct(filters)
				.then((data) => {
					if (data.results.length === 0) {
						setShowEmptyMessage(true);
					} else {
						setShowEmptyMessage(false);
					}
					setLocationList(loadNodes(data.results));
					setTotalItens(data.count);

					setNoReasonMaterial(getNoReasonCount(data));

					if (filters && filters.page) {
						setCurrentPage(filters.page);
					}
					setIsSorting(false);
				})
				.catch(() => setIsSorting(false));
		}
	};

	const loadNodes = (infos: any) => {
		let nodes: any = [];

		infos.forEach((node: any) => {
			let n = {
				key: node.key,
				data: node.data,
				leaf: !node.data.leaf,
			};

			nodes.push(n);
		});

		return nodes;
	};

	const onExpand = (event: any) => {
		if (!event.node.children) {
			setIsSorting(true);

			let params = {
				material_type: event.node.data.type.toLowerCase(),
				material_id: event.node.data.id,
			};

			managerProductLeaf(params)
				.then((response: any) => {
					let children: any = [];
					let noReason: ISelectedNode[] = [];
					let noReasonMedia: number[] = [];
					let list = locationList;
					let onPageSelected = perPageSelectedMaterial;

					response.data.forEach((node: any) => {
						let n = {
							key: node.key,
							data: node.data,
							leaf: !node.data.leaf,
						};

						switch (n.data.type) {
							case "Item":
								if (
									!n.data.reason &&
									disciplines.some(
										(i) => i.id === n.data.discipline,
									)
								) {
									noReason.push({
										id: n.data.id,
										children_selected: true,
									});

									let i = list.findIndex(
										(no) => no.key === event.node.key,
									);
									list = list.filter(
										(no: any) =>
											no.data.id !== event.node.data.id,
									);

									list.splice(i, 0, event.node);
								}
								break;
							case "Media":
								if (
									!n.data.reason &&
									items.some((i) => i.id === n.data.item)
								) {
									noReasonMedia.push(n.data.id);
								}
								break;

							default:
								break;
						}

						children.push(n);
					});

					onPageSelected[currentPage] += noReason.length;
					onPageSelected[currentPage] += noReasonMedia.length;

					setItems([...items, ...noReason]);
					setObjects([...objects, ...noReasonMedia]);
					setPerPageSelectedMaterial(onPageSelected);

					if (event.node.data.type === "Discipline") {
						//Acha o index do event.node --- Se o node for um children e não estiver na lista principal da pagina,
						//findIndex sempre retorna -1, ocorrendo em um bug de duplicação do node
						let i = list.findIndex(
							(no) => no.key === event.node.key,
						);

						list[i].children = children;
						setLocationList(list);

						// Discipline children_select = False
						if (
							disciplines.some((i) => i.id === event.node.data.id)
						) {
							let listDisciplines = disciplines;
							let nodeDiscipline = listDisciplines.findIndex(
								(discipline) =>
									discipline.id === event.node.data.id,
							);

							listDisciplines[nodeDiscipline].children_selected =
								false;
							setDisciplines(listDisciplines);
						}
					} else if (
						event.node.data.type === "Item" ||
						event.node.data.type === "Theme"
					) {
						const findNode = list.findIndex(
							(node) => node.key === event.node.key,
						);

						if (findNode >= 0) {
							list[findNode].children = children;
						} else {
							// Adiciona as children no event.node
							event.node.children = children;
						}

						// Item children_select = False
						if (items.some((i) => i.id === event.node.data.id)) {
							let listItems = items;
							let nodeItem = listItems.findIndex(
								(discipline) =>
									discipline.id === event.node.data.id,
							);

							listItems[nodeItem].children_selected = false;
							setItems(listItems);
						}
					}

					setLocationList(list);
					setNoReasonMaterial(
						noReasonMaterial + (response.reason - 1),
					);
				})
				.finally(() => {
					setIsSorting(false);
				});
		}
	};

	useEffect(() => {
		const timeOutId = setTimeout(() => {
			handleOnChange(query, "q");
			handleApplyFilters();
		}, 500);
		return () => clearTimeout(timeOutId);
	}, [query]);

	useEffect(() => {
		if (clearFilters) {
			handleApplyFilters();
			setClearFilters(false);
		}
	}, [clearFilters]);

	const categoryTemplate = (option: any) => {
		return (
			<div>
				<ObjectsCategoryIcon
					style={{ textAlign: "left" }}
					className={`material-icons-${option.category_icon}`}
				>
					{option.category_icon.split(" ")[1]}
				</ObjectsCategoryIcon>
				<span
					style={{ verticalAlign: "text-bottom", marginLeft: "5px" }}
				>
					{option.title}
				</span>
			</div>
		);
	};

	function publishTemplate(node: any) {
		let canPublishLocation = false;
		let canPublishStore = false;

		//indicators
		let html = null;

		if (node.data.price === null) {
			html = (
				<>
					<li>{translation("manager.indicators.noPrice")}</li>
				</>
			);
		}

		if (node.data.reason) {
			html = (
				<>
					{html}
					<li>
						{translation(
							"manager.labels." +
								node.data.type.toLowerCase() +
								"." +
								node?.data?.reason,
						)}
					</li>
				</>
			);
		}

		if (
			node.data.deadline === "Prompt Delivery" &&
			node.data.leaf === false
		) {
			if (node.data.type === "Discipline") {
				html = (
					<>
						{html}
						<li>
							{translation(
								"manager.labels.discipline.not_objects",
							)}
						</li>
					</>
				);
			}
			if (node.data.type === "Item") {
				html = (
					<>
						{html}
						<li>{translation("manager.labels.item.no_media")}</li>
					</>
				);
			}
			if (node.data.type === "Theme") {
				html = (
					<>
						{html}
						<li>{translation("manager.labels.theme.no_media")}</li>
					</>
				);
			}
		}
		//indicators

		if (node.data.can_publish) {
			canPublishLocation = true;
		} else {
			canPublishLocation = false;
		}

		if (node.data.price !== null && node.data.can_publish) {
			canPublishStore = true;
		} else {
			canPublishStore = false;
		}

		if (viewTableTypeValue === "manager") {
			return (
				<div className="font-14">
					{node.data.is_published || node.data.is_published_store ? (
						<div className="d-flex justify-content-center position-relative">
							{html !== null && (
								<OverlayTrigger
									overlay={
										<Tooltip id="tooltip-disabled">
											<ul className="list-indicators">
												{html}
											</ul>
										</Tooltip>
									}
								>
									<span className="indicator-position">
										<MdInfoOutline
											style={{ color: "#F39035" }}
										/>
									</span>
								</OverlayTrigger>
							)}
							<p className="mb-0 ml-1">Publicado</p>
						</div>
					) : (
						<div className="d-flex justify-content-center position-relative">
							{html !== null && (
								<OverlayTrigger
									overlay={
										<Tooltip id="tooltip-disabled">
											<ul className="list-indicators">
												{html}
											</ul>
										</Tooltip>
									}
								>
									<span className="indicator-position">
										<MdInfoOutline
											style={{ color: "#F39035" }}
										/>
									</span>
								</OverlayTrigger>
							)}
							<p className="mb-0 ml-1">Despublicado</p>
						</div>
					)}
				</div>
			);
		} else {
			return (
				<div className="d-flex align-items-center justify-content-center position-relative">
					{html !== null && (
						<OverlayTrigger
							overlay={
								<Tooltip id="tooltip-disabled">
									<ul className="list-indicators">{html}</ul>
								</Tooltip>
							}
						>
							<span className="indicator-position-publication">
								<MdInfoOutline style={{ color: "#F39035" }} />
							</span>
						</OverlayTrigger>
					)}

					{canPublishLocation && canPublishStore && (
						<Button
							variant="link"
							style={{ textDecoration: "none" }}
							type="button"
							onClick={() =>
								handleProductPublish(
									node,
									canPublishLocation,
									canPublishStore,
								)
							}
							disabled={!node.data.is_active}
						>
							{node.data.is_published &&
							node.data.is_published_store
								? "Despublicar"
								: (node.data.is_published &&
											!node.data.is_published_store) ||
									  (!node.data.is_published &&
											node.data.is_published_store)
									? "Gerenciar"
									: (!node.data.is_location &&
												!node.data.is_store) ||
										  node.data.is_location ||
										  node.data.is_store
										? "Publicar"
										: ""}
						</Button>
					)}

					{!canPublishLocation && !canPublishStore && (
						<Button
							variant="link"
							style={{ textDecoration: "none" }}
							type="button"
							disabled={true}
						>
							Publicar
						</Button>
					)}

					{canPublishLocation && !canPublishStore && (
						<Button
							variant="link"
							style={{ textDecoration: "none" }}
							type="button"
							onClick={() =>
								handleProductPublish(
									node,
									canPublishLocation,
									canPublishStore,
								)
							}
							disabled={!node.data.is_active}
						>
							{node.data.is_published
								? "Despublicar"
								: "Publicar"}
						</Button>
					)}

					{!canPublishLocation && canPublishStore && (
						<OverlayTrigger
							overlay={
								<Tooltip>
									<ul className="list-indicators">
										Publicar ou Despublicar
									</ul>
								</Tooltip>
							}
						>
							<Button
								variant="link"
								style={{ textDecoration: "none" }}
								type="button"
								onClick={() =>
									handleProductPublish(
										node,
										canPublishLocation,
										canPublishStore,
									)
								}
								disabled={!node.data.is_active}
							>
								{node.data.is_published_store
									? "Gerenciar"
									: "Publicar"}
							</Button>
						</OverlayTrigger>
					)}
				</div>
			);
		}
	}

	const handleMaterialActive = (node: any, activate: boolean = false) => {
		setSelectedNode(node.data);
		setSelectedFullNode(node);

		if (!activate) {
			setInactivateModalConfirm(true);
		} else if (activate) {
			managerProductActivate(node.data.id, node.data.type)
				.then(() => {
					handleUpdateList({}, "Material ativado com sucesso!");
					setSelectedNode(null);
					setActionSelected(2);
				})
				.catch(() => {
					toast.error("Erro ao ativar o material!");
				});
		}
	};

	function handleConfirmMaterialInactivate() {
		if (selectedNode.id) {
			setLoadingModal(true);
			managerProductInactivate(selectedNode.id, selectedNode.type)
				.then(() => {
					handleUpdateList({}, "Material inativado com sucesso!");
					setInactivateModalConfirm(false);
					setLoadingModal(false);
					setSelectedNode(null);
					setActionSelected(1);
				})
				.catch(() => setLoadingModal(false));
		}
	}

	const handleDeleteMaterial = (node: any) => {
		setSelectedNode(node.data);
		setSelectedFullNode(node);
		setDeleteModalConfirm(true);
	};

	function handleConfirmMaterialDelete() {
		if (selectedNode.id) {
			setLoadingModal(true);
			managerProductRemove(selectedNode.id, selectedNode.type)
				.then(() => {
					handleUpdateList({}, "Material excluído com sucesso!");
					setDeleteModalConfirm(false);
					setLoadingModal(false);
					setSelectedNode(null);
					setActionSelected(1);
				})
				.catch(() => setLoadingModal(false));
		}
	}

	function handleMaterialUpdatePrice(node: any) {
		if (node.data.id) {
			setLoadingModal(true);
			managerUpdatePrice(node.data.id, node.data.type).then(() => {
				toast.success("Material atualizado com sucesso!");
				setLoadingModal(false);
			});
		}
	}

	function handleBatchMaterialUpdatePrice() {
		const object = {
			disciplines,
			items,
			objects,
			is_public: batchAction,
			publish_store: batchToStore,
			publish_location: batchToLocation,
		};

		setLoading(true);
		managerUpdatePriceBatch(object).then(() => {
			toast.success("Materiais atualizados com sucesso!", {
				position: "bottom-center",
			});
			setPerPageSelectedMaterial({});
			setLoading(false);
		});
	}

	function actionTemplate(node: any) {
		let items: any = [];
		let id = node.data.id;

		items.push({
			template: (
				<ActionItemLink
					url={
						"/manager/material/" +
						node.data.type.toLowerCase() +
						"/" +
						id
					}
				>
					Visualizar material
				</ActionItemLink>
			),
		});

		items.push({
			label: "Atualizar preço",
			command: () => {
				handleMaterialUpdatePrice(node);
			},
		});

		if (node.data.is_active === true) {
			// somente materiais despublicados podem ser inativados
			if (!(node.data.is_published || node.data.is_published_store)) {
				items.push({
					label: "Inativar material",
					command: () => {
						handleMaterialActive(node, false);
					},
				});
			}

			if (
				node.data.product_origin === "Externo" ||
				node.data.product_origin === "External"
			) {
				items.push({
					label: "Atualizar material",
					command: () => {
						updateMaterial(node);
					},
				});
			}
		} else if (node.data.is_active === false) {
			items.push({
				label: "Ativar material",
				command: () => {
					handleMaterialActive(node, true);
				},
			});
			items.push({
				label: "Excluir material",
				command: () => {
					handleDeleteMaterial(node);
				},
			});
		}

		return (
			<OverlayTrigger
				placement="top"
				overlay={<Tooltip>Opções</Tooltip>}
			>
				<div>
					<SplitButton
						label=""
						className="p-button p-component p-button-rounded p-button-text p-button-icon-only"
						buttonClassName="d-none"
						dropdownIcon={<FaEllipsisH />}
						model={items}
					/>
				</div>
			</OverlayTrigger>
		);
	}

	const updateMaterial = async (node: any) => {
		let obj = handleObjUpdateMaterials(node);
		integrationUpdateImportMaterials(obj)
			.then(() => {
				toast.success("Material atualizado com sucesso!");
				handleApplyFilters();
			})
			.catch((err) => {
				toast.error(err.response.data.message);
			});
	};

	function handleObjUpdateMaterials(node: any) {
		let disciplinesToUpdate = [];
		let themesToUpdate = [];
		let itemsToUpdate = [];
		let mediasToUpdate = [];

		if (node.data.type === "Discipline") {
			disciplinesToUpdate.push(node.data.id);
		} else if (node.data.type === "Theme") {
			themesToUpdate.push(node.data.id);
		} else if (node.data.type === "Item") {
			itemsToUpdate.push(node.data.id);
		} else {
			mediasToUpdate.push(node.data.id);
		}

		if (node.children && node.children.length > 0) {
			node.children.forEach((child: any) => {
				if (child.data.type === "Discipline") {
					disciplinesToUpdate.push(child.data.id);
				} else if (child.data.type === "Theme") {
					themesToUpdate.push(child.data.id);
				} else if (child.data.type === "Item") {
					itemsToUpdate.push(child.data.id);
				} else {
					mediasToUpdate.push(child.data.id);
				}

				if (child.children && child.children.length > 0) {
					child.children.forEach((grandson: any) => {
						if (grandson.data.type === "Discipline") {
							disciplinesToUpdate.push(grandson.data.id);
						} else if (grandson.data.type === "Theme") {
							themesToUpdate.push(grandson.data.id);
						} else if (grandson.data.type === "Item") {
							itemsToUpdate.push(grandson.data.id);
						} else {
							mediasToUpdate.push(grandson.data.id);
						}
					});
				}
			});
		}

		return {
			disciplines: disciplinesToUpdate,
			themes: themesToUpdate,
			items: itemsToUpdate,
			medias: mediasToUpdate,
		};
	}

	const handleSelectDisciplineSheet = (e: any) => {
		setDisciplineSheet(e);
	};

	const handleSelectThemeSheet = (e: any) => {
		setThemeSheet(e);
	};

	const handleSubmitSheetsModal = () => {
		setLoadingModal(true);
		let obj: any = [];

		if (disciplineSheet && disciplineSheet.size > 0) {
			obj.push({
				file: disciplineSheet,
				material_type: 1,
			});
		} else if (disciplineSheet === null) {
			obj.push({
				file: null,
				material_type: 1,
			});
		}

		if (themeSheet && themeSheet.size > 0) {
			obj.push({
				file: themeSheet,
				material_type: 2,
			});
		} else if (themeSheet === null) {
			obj.push({
				file: null,
				material_type: 2,
			});
		}

		uploadSpredsheets(obj).then(() => {
			setShowAddSpreadsheetModal(false);
			setLoadingModal(false);
		});
	};

	const handleBatchReImport = () => {
		const object = {
			disciplines,
			items,
			objects,
		};
		setshowSchedulingImportModal(false);
		integrationScheduleUpdateImportMaterials(object)
			.then(() => {
				toast.success("Atualização agendada com sucesso!");
				setDisciplines([]);
				setItems([]);
				setObjects([]);
				setBatchAction(0);
				setLoading(true);
				managerProduct()
					.then((data) => {
						if (data.results.length === 0) {
							setShowEmptyMessage(true);
						} else {
							setShowEmptyMessage(false);
						}
						setLocationList(loadNodes(data.results));
						setTotalItens(data.count);

						setNoReasonMaterial(getNoReasonCount(data));

						setLoading(false);
					})
					.catch(() => setLoading(false));
			})
			.catch((e) => {
				toast.error(e.message);
			});
	};

	const handleBatch = () => {
		switch (batchAction) {
			case 7:
				setShowDeleteMaterialModal(true);
				break;
			case 6:
				handleBatchReactivate();
				break;
			case 5:
				setShowInativateMaterialModal(true);
				break;
			case 4:
				handleBatchMaterialUpdatePrice();
				break;
			case 3:
				setshowSchedulingImportModal(true);
				break;
			// 2 para publicar
			// 1 para despublicar
			case 2:
			case 1:
				setShowBatchPublishModal(true);
				break;

			default:
				break;
		}
	};

	/**
	 * Publica ou despublica em massa os materiais selecionados
	 */
	const handleBatchConfirmation = () => {
		const object = {
			disciplines,
			items,
			objects,
			is_public: batchAction,
			publish_store: batchToStore,
			publish_location: batchToLocation,
		};

		productBatch(object)
			.then((res) => {
				toast.success(res.message, { position: "bottom-center" });
				setLoading(true);
				setBatchAction(0);
				setBatchToLocation(false);
				setBatchToStore(false);

				managerProduct(filters)
					.then((data) => {
						if (data.results.length === 0) {
							setShowEmptyMessage(true);
						} else {
							setShowEmptyMessage(false);
						}
						setLocationList(loadNodes(data.results));
						setTotalItens(data.count);

						setNoReasonMaterial(getNoReasonCount(data));

						let perPageMaterial = perPageSelectedMaterial;
						perPageMaterial[currentPage] = 0;
						setPerPageSelectedMaterial({});
						setLoading(false);
					})
					.catch(() => setLoading(false));
			})
			.catch((e) => {
				toast.error(e.message);
				setBatchAction(0);
			});
	};

	/**
	 * Inativa os materiais em lote
	 */
	const handleBatchInativateConfirmation = () => {
		const object = {
			disciplines,
			items,
			objects,
			is_public: batchAction,
			publish_store: batchToStore,
			publish_location: batchToLocation,
		};

		setLoading(true);
		productInativateBatch(object)
			.then((resp) => {
				setLoading(true);
				setBatchAction(0);
				handleClearSlection();
				handleUpdateList(resp, resp.message);
			})
			.catch((e) => {
				toast.error(e.message);
				setBatchAction(0);
				setLoading(false);
			});
	};

	/**
	 * Ativa os materiais em lote
	 */
	function handleBatchReactivate() {
		const object = {
			disciplines,
			items,
			objects,
		};

		setLoading(true);
		productReactivateBatch(object)
			.then((resp) => {
				setLoading(true);
				handleUpdateList(resp, resp.message);
				setBatchAction(0);
				handleClearSlection();
			})
			.catch((e) => {
				toast.error(e.message);
				setBatchAction(0);
				setLoading(false);
			});
	}

	/**
	 * Deleta os materiais em lote
	 */
	const handleBatchDeleteConfirmation = () => {
		const object = {
			disciplines,
			items,
			objects,
		};

		setLoading(true);
		productDeleteBatch(object)
			.then((resp) => {
				setLoading(true);
				handleUpdateList(resp, resp.message);
				setBatchAction(0);
				handleClearSlection();
			})
			.catch((e) => {
				toast.error(e.message);
				setBatchAction(0);
				setLoading(false);
			});
	};

	const handleChangeAddOption = (option: string) => {
		if (option === "add_material") {
			history.push(`/manager/add-materials`);
		} else {
			if (user.is_superuser) {
				setShowAddSpreadsheetModal(true);
			}
		}
	};

	const handleTextFilters = () => {
		let filter = 0;
		let text = "";

		if (category.length > 0) {
			filter++;
		}

		if (materialType.length > 0) {
			filter++;
		}

		if (indicatorsFilter.length > 0) {
			filter++;
		}

		if (partnersSelected.length > 0) {
			filter++;
		}

		if (deadlineFilter.length > 0) {
			filter++;
		}

		if (projectFilter.length > 0) {
			filter++;
		}

		switch (filter) {
			case 1:
				text = "1 filtro selecionado";
				break;

			case 2:
				text = "2 filtros selecionados";
				break;

			case 3:
				text = "3 filtros selecionados";
				break;
			case 4:
				text = "4 filtros selecionados";
				break;
			case 5:
				text = "5 filtros selecionados";
				break;
		}

		return text;
	};

	const handleButtonClear = () => {
		setQuery("");
		setCategory([]);
		setMaterialType([]);
		setIndicatorsFilter([]);
		setDeadlineFilter([]);
		setProjectFilter([]);
		setPartnersSelected([]);
		handleFilters({
			q: "",
			page: 1,
		});
		setClearFilters(true);
	};

	const handleApplyFilters = () => {
		setShowFilterSidebar(false);
		if (filters && filters.page && !isSorting) {
			setIsSorting(true);
			handleClearSlection();
			managerProduct(filters)
				.then((data) => {
					if (data.results.length === 0) {
						setShowEmptyMessage(true);
					} else {
						setShowEmptyMessage(false);
					}
					setLocationList(loadNodes(data.results));
					setTotalItens(data.count);

					setNoReasonMaterial(getNoReasonCount(data));

					if (filters && filters.page) {
						setCurrentPage(filters.page);
					}
					setIsSorting(false);
				})
				.catch(() => setIsSorting(false));
		}
	};

	const handleSelectAllMaterial = () => {
		managerProductSelectAll(filters).then((data) => {
			if (data.discipline) {
				let discipleList = [...data.discipline];
				// discipleList = discipleList.filter(
				// 	(disc) => disc.can_publish === true
				// );
				setDisciplines(discipleList);
			}
			if (data.items || data.themes) {
				let lista = [...data.items, ...data.themes];
				// lista = lista.filter((obj) => obj.can_publish === true);
				setItems(lista);
			}

			if (data.medias) {
				let medias = [...data.medias];
				// medias = medias.filter((obj) => obj.can_publish === true);
				setObjectsComposed(medias);
				medias = medias.map((data) => data.id);
				setObjects(medias);
			}

			setAllSelected(true);
		});
	};

	//Custom columns

	let colOptions = [];
	for (let col of columns) {
		colOptions.push({ label: col.header, value: col });
	}

	let viewTableOptions = [
		{ label: "Gerenciamento", value: "manager" },
		{ label: "Publicação", value: "publish" },
	];

	let addOptions = [
		{ label: "Adicionar Planilha", value: "add_sheet" },
		{ label: "Adicionar Material", value: "add_material" },
	];

	useEffect(() => {
		let columsStorage = localStorage.getItem("dstore-columns");
		let jsonColumnsStorage: any = {};

		if (columsStorage) {
			jsonColumnsStorage = JSON.parse(columsStorage);
			setCols(jsonColumnsStorage);
		}
	}, []);

	const [cols, setCols] = useState<any[]>(columns);

	const onColumnToggle = (event: any) => {
		let selectedColumns = event.value;
		let orderedSelectedColumns = columns.filter((col: any) =>
			selectedColumns.some((sCol: any) => sCol.field === col.field),
		);
		setCols(orderedSelectedColumns);
		localStorage.setItem(
			"dstore-columns",
			JSON.stringify(orderedSelectedColumns),
		);
	};

	//Custom columns

	const changeViewTable = (value: any) => {
		setViewTableTypeValue(value);
		setLoading(true);

		if (value === "manager") {
			setTreeTableConfig([
				{
					field: "title",
					header: "Nome",
					className: "sm-text",
					nameTemplate: true,
					expander: true,
					sortable: true,
					style: { textAlign: "left", width: "35%" },
				},
				{
					field: "type_name",
					className: "d-none d-sm-table-cell",
					header: "Tipo",
					sortable: false,
					style: { textAlign: "center" },
				},
				{
					field: "responsible",
					className: "d-none d-sm-table-cell",
					header: "Parceiro",
					sortable: false,
					style: { textAlign: "center" },
				},
				{
					field: "code",
					className: "d-none d-sm-table-cell",
					header: "Código",
					sortable: true,
					style: {
						textAlign: "center",
						overflow: "hidden",
						textOverflow: "ellipsis",
						maxWidth: 150,
					},
				},
				{
					field: "product_origin",
					className: "d-none d-sm-table-cell",
					header: "Origem",
					sortable: true,
					style: { textAlign: "center" },
				},
			]);

			setColumns([
				{ field: "code", header: "Código" },
				{ field: "product_origin", header: "Origem" },
				{ field: "responsible", header: "Parceiro" },
				{ field: "status", header: "Status" },
				{ field: "type_name", header: "Tipo" },
			]);
		} else if (value === "publish") {
			setTreeTableConfig([
				{
					field: "title",
					header: "Nome",
					className: "sm-text",
					nameTemplate: true,
					expander: true,
					sortable: true,
					style: { textAlign: "left", width: "35%" },
				},
				{
					field: "type_name",
					className: "d-none d-sm-table-cell",
					header: "Tipo",
					sortable: false,
					style: { textAlign: "center" },
				},
				{
					field: "location",
					className: "d-none d-sm-table-cell",
					locationTemplate: true,
					header: "Locação",
					sortable: false,
					style: { textAlign: "center" },
				},
				{
					field: "store",
					className: "d-none d-sm-table-cell",
					storeTemplate: true,
					header: "Loja",
					sortable: false,
					style: { textAlign: "center" },
				},
			]);
			setColumns([
				{ field: "location", header: "Locação" },
				{ field: "store", header: "Loja" },
				{ field: "status", header: "Status" },
				{ field: "type_name", header: "Tipo" },
			]);
		}

		setLoading(false);
	};

	return (
		<>
			<Container fluid>
				<Row>
					{!showSearchBar ? (
						<ActionRibbon className="d-flex flex-wrap text-black">
							<div className="dropdown-table-view">
								<Dropdown
									options={viewTableOptions}
									value={viewTableTypeValue}
									placeholder="Tipo de visualização"
									onChange={(e: any) =>
										changeViewTable(e.target.value)
									}
								/>
							</div>

							<div
								className={`div-item-navbar ${
									query !== "" ? "selected-item" : ""
								}`}
								style={{ marginRight: "0px" }}
								onClick={() => setShowSearchBar(true)}
							>
								Pesquisar{" "}
								<MdSearch
									className="ml-2"
									size="22"
								/>
							</div>

							<MultiSelect
								value={cols}
								options={colOptions}
								id="dropdown"
								className="item-dropdown-manager-bar"
								panelClassName="item-panel-dropdown-manager-bar"
								placeholder="Personalizar colunas"
								maxSelectedLabels={1}
								selectedItemsLabel="Personalizar colunas"
								onChange={onColumnToggle}
								dropdownIcon={<MdOutlineViewColumn size="22" />}
							/>

							<Dropdown
								options={addOptions}
								className="item-dropdown-manager-bar"
								placeholder="Adicionar"
								dropdownIcon={"pi pi-plus"}
								onChange={(e: any) =>
									handleChangeAddOption(e.target.value)
								}
							/>

							<div
								className={`div-item-navbar ${
									showImportModal && "selected"
								}`}
								onClick={() => handleImportModal()}
							>
								Importar{" "}
								<MdOutlineImportExport
									className="ml-1"
									size="20"
								/>
							</div>

							{category.length > 0 ||
							materialType.length > 0 ||
							indicatorsFilter.length > 0 ||
							partnersSelected.length > 0 ||
							deadlineFilter.length > 0 ||
							projectFilter.length > 0 ? (
								<OverlayTrigger
									placement={"bottom"}
									overlay={
										<Tooltip>{handleTextFilters()}</Tooltip>
									}
								>
									<div
										className={`div-item-navbar selected-item`}
										onClick={() =>
											setShowFilterSidebar(true)
										}
									>
										Filtros{" "}
										<MdFilterList
											className="ml-2"
											size="20"
										/>
									</div>
								</OverlayTrigger>
							) : (
								<div
									className={`div-item-navbar ${
										showFilterSidebar && "selected"
									}`}
									onClick={() => setShowFilterSidebar(true)}
								>
									Filtros{" "}
									<MdFilterList
										className="ml-2"
										size="20"
									/>
								</div>
							)}

							{(category.length > 0 ||
								materialType.length > 0 ||
								indicatorsFilter.length > 0 ||
								deadlineFilter.length > 0 ||
								partnersSelected.length > 0 ||
								query !== "") && (
								<Button
									variant="outline-primary"
									style={{ margin: "0 2px 0 auto" }}
									onClick={() => handleButtonClear()}
								>
									{translation("filters.clearFilters")}
								</Button>
							)}

							{disciplines.length +
								items.length +
								objects.length >=
								2 && (
								<BatchActions>
									<Col>
										<Form.Select
											value={batchAction}
											onChange={(e) =>
												setBatchAction(
													parseInt(e.target.value),
												)
											}
										>
											<option value={0}>
												Ação em lote
											</option>
											<option value={2}>Publicar</option>
											<option value={1}>
												Despublicar
											</option>
											<option value={3}>
												Sincronizar Materiais
											</option>
											<option value={4}>
												Atualizar precificação
											</option>
											<option value={5}>Inativar</option>
											<option value={6}>Reativar</option>
											<option value={7}>Excluir</option>
										</Form.Select>
									</Col>
									<Col>
										{!batchAction ? (
											<OverlayTrigger
												placement={"top"}
												overlay={
													<Tooltip>
														Escolha uma das opções
														para poder aplicar.
													</Tooltip>
												}
											>
												<DisabledButton>
													<button
														name="addbutton"
														type="submit"
													>
														Aplicar
													</button>
												</DisabledButton>
											</OverlayTrigger>
										) : (
											<PrimaryButton
												onClick={handleBatch}
											>
												<button
													disabled={!batchAction}
													name="addbutton"
													type="submit"
												>
													Aplicar
												</button>
											</PrimaryButton>
										)}
									</Col>
								</BatchActions>
							)}
						</ActionRibbon>
					) : (
						<ActionRibbon className="d-flex text-black">
							<div className="dropdown-table-view">
								<Dropdown
									options={viewTableOptions}
									value={viewTableTypeValue}
									placeholder="Tipo de visualização"
									onChange={(e: any) =>
										changeViewTable(e.target.value)
									}
								/>
							</div>

							<div
								className="div-item-navbar selected"
								onClick={() => setShowSearchBar(false)}
							>
								Pesquisar{" "}
								<MdSearch
									className="ml-2"
									size="22"
								/>
							</div>

							<Col style={{ maxWidth: 360 }}>
								<InputGroup className="ds-input-group">
									<InputGroup.Text id="basic-addon1">
										<MdSearch
											style={{ color: "#606060" }}
										/>
									</InputGroup.Text>
									<FormControl
										className="input-text"
										placeholder={translation(
											"manager.filters.product_search",
										)}
										aria-label={translation(
											"manager.filters.product_search",
										)}
										value={query}
										onChange={(event: any) =>
											setQuery(event.target.value)
										}
									/>
								</InputGroup>
							</Col>

							<Btn
								icon="pi pi-times"
								className="p-button-rounded text-darker-grey p-button-text clear-search-button"
								aria-label="Cancel"
								onClick={() => {
									setShowSearchBar(false);
								}}
							/>
						</ActionRibbon>
					)}
				</Row>
				<hr className="mt-1" />

				<ContentBody>
					<Row>
						{loading ? (
							<NotFound>
								<Spinner
									animation="border"
									variant="primary"
									style={{
										width: "3rem",
										height: "3rem",
										borderWidth: "0.25em",
										borderRightColor: "transparent",
									}}
								/>
							</NotFound>
						) : (
							<>
								{showEmptyMessage ? (
									<div className="text-center text-grey mt-5">
										<FaFolder
											className="mt-5"
											size={100}
										/>
										<h5 className="text-grey">
											{translation(
												"manager.products.emptyMaterials",
											)}
										</h5>
									</div>
								) : (
									<>
										<Col
											className="d-flex gap-3 align-items-center mb-2"
											style={{
												height: 38,
											}}
										>
											{disciplines.length +
											items.length +
											objects.length ? (
												<SelectAllInfo
													totalItens={totalItens}
													totalSelected={
														disciplines.length +
														items.length +
														objects.length
													}
													allSelected={allSelected}
													checkAllType={checkAllType}
													handleClearSelection={
														handleClearSlection
													}
													handleSelectAllMaterial={
														handleSelectAllMaterial
													}
												></SelectAllInfo>
											) : (
												<span
													style={{
														color: "#606060",
														fontSize: 14,
													}}
												>
													{totalItens} resultado
													{totalItens > 1
														? "s "
														: " "}
													encontrado
													{totalItens > 1 ? "s" : ""}
												</span>
											)}
										</Col>
										<TreeTableProductsList
											isManagerTable
											isRowSelect
											disciplines={disciplines}
											items={items}
											objects={objects}
											customColumns={cols}
											setDisciplines={(val: any) =>
												setDisciplines(val)
											}
											setNoReason={(val: any) =>
												setNoReasonMaterial(val)
											}
											setItems={(val: any) =>
												setItems(val)
											}
											setObjects={(val: any) =>
												setObjects(val)
											}
											perPageSelectedMaterial={
												perPageSelectedMaterial
											}
											setPerPageSelectedMaterial={(val: {
												[keys: number]: number;
											}) =>
												setPerPageSelectedMaterial(val)
											}
											setActionSelected={(val: any) =>
												setActionSelected(val)
											}
											noReasonMaterial={noReasonMaterial}
											currentPage={currentPage}
											selectedFullNode={selectedFullNode}
											actionSelected={actionSelected}
											onExpand={onExpand}
											handleUpdateList={handleUpdateList}
											treeFields={treeTableConfig}
											nodes={locationList}
											handleTableSort={handleTableSort}
											sortField={sortField}
											sortOrder={sortOrder}
											loading={isSorting}
											handleClearSlection={() =>
												handleClearSlection()
											}
											handleChangeCheckAllType={(
												value: any,
											) =>
												handleChangeCheckAllType(value)
											}
											allSelected={allSelected}
										>
											{cols.filter(
												(c) => c.field === "status",
											).length !== 0 && (
												<Column
													field="status"
													header="Status"
													style={{
														textAlign: "center",
														width: "17%",
													}}
													body={publishTemplate}
												></Column>
											)}

											{/* <Column field="reimport" className="sm-actions" header="" style={{ textAlign: 'center', width: '4%', padding: '0px' }} body={reimportTemplate}></Column> */}
											<Column
												field="actions"
												className="sm-actions"
												header=""
												style={{
													textAlign: "left",
													width: "4%",
													padding: "0px",
												}}
												body={actionTemplate}
											></Column>
										</TreeTableProductsList>
									</>
								)}
							</>
						)}
					</Row>
					<Row className="mt-5 mb-3">
						{!loading && locationList.length > 0 ? (
							<PaginationList
								currentPage={currentPage}
								totalItems={totalItens}
								onPageChange={handlePageChange}
							></PaginationList>
						) : (
							<></>
						)}
					</Row>
				</ContentBody>

				<ModalImportProduct
					submitButtonText={"Importar"}
					show={showImportModal}
					handleHideModal={() => setImportModal(false)}
					variant="form-modal"
					onImport={handleImport}
					size={"lg"}
					loading={isImporting}
				/>

				<ModalWarningImportProduct
					show={showConfigImportModal}
					onSubmit={() => history.push(`/manager/settings`)}
					onHide={() => setConfigImportModal(false)}
					submitButtonText={"Configurar"}
					size={"sm"}
				>
					<p>
						Para importar materiais você precisa primeiro configurar
						a integração
					</p>
				</ModalWarningImportProduct>

				<Modal
					headerTitle={translation(
						"manager.labels.import.schedule_import_modal_title",
					)}
					submitButtonText={translation(
						"manager.labels.import.schedule_import_submit",
					)}
					show={showSchedulingImportModal}
					onHide={() => setshowSchedulingImportModal(false)}
					onSubmit={handleBatchReImport}
					variant="form-modal-default"
					loading={false}
					hasDefaultIcon={false}
				>
					<div style={{ textAlign: "center" }}>
						<p style={{ color: "#333333" }}>
							{translation(
								"manager.labels.import.schedule_import_message_1",
							)}
						</p>
						<p style={{ color: "#333333" }}>00:00 AM - 06:00 AM</p>
						<p style={{ color: "#333333" }}>
							{translation(
								"manager.labels.import.schedule_import_message_2",
							)}
						</p>
					</div>
				</Modal>

				<Modal
					headerTitle="Aviso"
					submitButtonText={translation(
						"manager.products.inactivate",
					)}
					show={showInactivateModalConfirm}
					onHide={() => setInactivateModalConfirm(false)}
					onSubmit={handleConfirmMaterialInactivate}
					variant="confirm-modal-default"
					loading={loadingModal}
					fullSizeLoader
				>
					<p>
						Tem certeza que deseja inativar o material{" "}
						<b className="span-ellipsis">{selectedNode?.title}?</b>
					</p>
					<p>Todos os links do material serão inativados.</p>
				</Modal>

				<Modal
					headerTitle="Aviso"
					submitButtonText={translation("manager.products.remove")}
					show={showDeleteModalConfirm}
					onHide={() => setDeleteModalConfirm(false)}
					onSubmit={handleConfirmMaterialDelete}
					variant="confirm-modal"
					loading={loadingModal}
				>
					<p>
						Tem certeza que deseja excluir o material{" "}
						<b className="span-ellipsis">{selectedNode?.title}?</b>
					</p>
					<p>Todos os links do material serão excluídos.</p>
				</Modal>

				<Modal
					headerTitle="Aviso"
					submitButtonText={translation("manager.products.unpublish")}
					show={showUnpublishModalConfirm}
					onHide={() => setUnpublishModalConfirm(false)}
					onSubmit={handleConfirmProductUnpublish}
					variant="confirm-modal-default"
					loading={loadingModal}
				>
					<p>
						Tem certeza que deseja despublicar o material{" "}
						<b className="span-ellipsis">{selectedNode?.title}?</b>
					</p>
					{selectedNode?.links && selectedNode.links >= 0 ? (
						<>
							<p>
								O material está sendo utilizado por{" "}
								{selectedNode?.links} usuários
							</p>
						</>
					) : (
						<></>
					)}
				</Modal>

				<Modal
					headerTitle="Publicação"
					submitButtonText={translation("manager.user.confirm")}
					show={showPublishedOptionsModal}
					onHide={() => setShowPublishedOptionsModal(false)}
					onSubmit={handleConfirmPublishOptions}
					variant="form-modal-default"
					loading={loadingModal}
					disableOnSubmit={
						(selectedNode?.is_published
							? checkboxIsLocation
							: !checkboxIsLocation) &&
						(selectedNode?.is_published_store
							? checkboxIsStore
							: !checkboxIsStore)
					}
					sizeApply
				>
					<Row>
						<Col
							xs={12}
							className="pl-0"
						>
							<p className="text-darker-grey">
								Escolha a ação que deseja executar e clique em
								confirmar.
							</p>
						</Col>
						<Col
							xs={6}
							className="pl-0"
						>
							<Card className="text-darker-grey card-options-publish mb-3">
								<Card.Body>
									<MdOutlineCollectionsBookmark
										className="mr-1"
										size="19"
									/>{" "}
									Locação
								</Card.Body>
							</Card>

							<Form.Check type="checkbox">
								<Form.Check.Input
									id="check-options-publish-location"
									type="checkbox"
									isValid
									checked={
										selectedNode?.is_published
											? !checkboxIsLocation
											: checkboxIsLocation
									}
									onChange={() =>
										setCheckboxIsLocation(
											!checkboxIsLocation,
										)
									}
									disabled={
										selectedNode?.is_published === true &&
										selectedNode?.reason_location === false
											? true
											: false
									}
								/>
								<Form.Check.Label
									style={{
										color: "#606060",
										fontSize: "14px",
									}}
									htmlFor="check-options-publish-location"
								>
									{selectedNode?.is_location
										? selectedNode?.is_published
											? "Despublicar o material"
											: "Publicar o material"
										: selectedNode?.is_published
											? "Despublicar o material"
											: "Ativar e publicar o material"}
								</Form.Check.Label>
							</Form.Check>
							{selectedNode?.is_published === true &&
								selectedNode?.reason_location === false && (
									<>
										<span
											className="font-12"
											style={{ color: "#F39035" }}
										>
											{selectedNode?.type !== "Media" ? (
												<>
													<MdInfoOutline /> Não é
													possível deixar publicado
													uma disciplina sem unidades
												</>
											) : (
												<>
													<MdInfoOutline /> Não é
													possível deixar publicado
													uma unidade sem objetos
												</>
											)}
										</span>
									</>
								)}
						</Col>

						<Col
							xs={6}
							className="pr-0"
						>
							<Card className="text-darker-grey card-options-publish mb-3">
								<Card.Body>
									<MdStorefront
										className="mr-1"
										size="19"
									/>{" "}
									Loja
								</Card.Body>
							</Card>

							<Form.Check type="checkbox">
								<Form.Check.Input
									id="check-options-publish-store"
									type="checkbox"
									isValid
									disabled={
										selectedNode?.price === null
											? true
											: selectedNode?.is_published_store ===
														true &&
												  selectedNode?.reason_store ===
														false
												? true
												: false
									}
									checked={
										selectedNode?.is_published_store
											? !checkboxIsStore
											: checkboxIsStore
									}
									onChange={() =>
										setCheckboxIsStore(!checkboxIsStore)
									}
								/>
								<Form.Check.Label
									style={{
										color: "#606060",
										fontSize: "14px",
									}}
									htmlFor="check-options-publish-store"
								>
									{selectedNode?.is_store
										? selectedNode?.is_published_store
											? "Despublicar o material"
											: "Publicar o material"
										: selectedNode?.is_published_store
											? "Despublicar o material"
											: "Ativar e publicar o material"}
								</Form.Check.Label>
							</Form.Check>
							{selectedNode?.price === null && (
								<>
									{selectedNode?.type !== "Media" &&
									selectedNode?.type !== "Theme" ? (
										<span
											className="font-12"
											style={{ color: "#F39035" }}
										>
											<MdInfoOutline /> Material sem preço
											cadastrado
										</span>
									) : (
										<span
											className="font-12"
											style={{ color: "#F39035" }}
										>
											Preço base não definido{" "}
											<MdInfoOutline />{" "}
											<a
												className="text-blueberry cursor-pointer ml-1"
												onClick={() =>
													history.push(
														"/manager/settings",
													)
												}
											>
												Configurar
											</a>
										</span>
									)}
								</>
							)}
							{selectedNode?.price !== null &&
								selectedNode?.is_published_store === true &&
								selectedNode?.reason_store === false && (
									<>
										<span
											className="font-12"
											style={{ color: "#F39035" }}
										>
											{selectedNode?.type !== "Media" ? (
												<>
													<MdInfoOutline /> Não é
													possível deixar publicado
													uma disciplina sem unidades
												</>
											) : (
												<>
													<MdInfoOutline /> Não é
													possível deixar publicado
													uma unidade sem objetos
												</>
											)}
										</span>
									</>
								)}
						</Col>
					</Row>
				</Modal>

				<Modal
					headerTitle="Planilhas"
					submitButtonText={translation("save")}
					show={showAddSpreadsheetModal}
					onHide={() => setShowAddSpreadsheetModal(false)}
					onSubmit={handleSubmitSheetsModal}
					variant="form-modal-default"
					loading={loadingModal}
					sizeApply={true}
				>
					{loadingModalPlanilha ? (
						<div className="text-center">
							<Spinner
								animation="border"
								variant="primary"
								style={{
									width: "2rem",
									height: "2rem",
									borderWidth: "0.25em",
									borderRightColor: "transparent",
								}}
							/>
						</div>
					) : (
						<Accordion
							defaultActiveKey={["0", "1"]}
							alwaysOpen
							className="add-planilhas"
						>
							<Accordion.Item
								eventKey="0"
								className="mb-3"
							>
								<Accordion.Header>Disciplinas</Accordion.Header>
								<Accordion.Body>
									<Row>
										<Col
											className="cursor-pointer d-flex align-items-center"
											onClick={() =>
												fileInputDiscipline?.current.click()
											}
										>
											{disciplineSheet ? (
												<p className="text-darker-grey mb-0 font-14">
													{disciplineSheet.name}
												</p>
											) : (
												<p className="mb-0 text-grey font-14">
													Selecionar arquivo
												</p>
											)}
											<input
												ref={fileInputDiscipline}
												type="file"
												className="d-none"
												accept=".xls,.xlsx,.csv"
												onChange={(e: any) =>
													handleSelectDisciplineSheet(
														e.target.files[0],
													)
												}
											/>
										</Col>
										<Col
											xs={2}
											md={2}
											className="text-end text-darker-grey"
										>
											{disciplineSheet ? (
												<OverlayTrigger
													placement={"top"}
													overlay={
														<Tooltip>
															Remover
														</Tooltip>
													}
												>
													<span
														className="cursor-pointer"
														onClick={() =>
															setDisciplineSheet(
																null,
															)
														}
													>
														<MdOutlineDelete size="24" />
													</span>
												</OverlayTrigger>
											) : (
												<OverlayTrigger
													placement={"top"}
													overlay={
														<Tooltip>
															Adicionar
														</Tooltip>
													}
												>
													<span
														className="cursor-pointer"
														onClick={() =>
															fileInputDiscipline?.current.click()
														}
													>
														<MdAddCircleOutline size="24" />
													</span>
												</OverlayTrigger>
											)}
										</Col>
									</Row>
								</Accordion.Body>
							</Accordion.Item>

							<Accordion.Item eventKey="1">
								<Accordion.Header>Temas</Accordion.Header>
								<Accordion.Body>
									<Row>
										<Col
											className="cursor-pointer d-flex align-items-center"
											onClick={() =>
												fileInputTheme?.current.click()
											}
										>
											{themeSheet ? (
												<p className="text-darker-grey mb-0 font-14">
													{themeSheet.name}
												</p>
											) : (
												<p className="mb-0 text-grey font-14">
													Selecionar arquivo
												</p>
											)}
											<input
												ref={fileInputTheme}
												type="file"
												className="d-none"
												accept=".xls,.xlsx,.csv"
												onChange={(e: any) =>
													handleSelectThemeSheet(
														e.target.files[0],
													)
												}
											/>
										</Col>
										<Col
											xs={2}
											md={2}
											className="text-end text-darker-grey"
										>
											{themeSheet ? (
												<OverlayTrigger
													placement={"top"}
													overlay={
														<Tooltip>
															Remover
														</Tooltip>
													}
												>
													<span
														className="cursor-pointer"
														onClick={() =>
															setThemeSheet(null)
														}
													>
														<MdOutlineDelete size="24" />
													</span>
												</OverlayTrigger>
											) : (
												<OverlayTrigger
													placement={"top"}
													overlay={
														<Tooltip>
															Adicionar
														</Tooltip>
													}
												>
													<span
														className="cursor-pointer"
														onClick={() =>
															fileInputTheme?.current.click()
														}
													>
														<MdAddCircleOutline size="24" />
													</span>
												</OverlayTrigger>
											)}
										</Col>
									</Row>
								</Accordion.Body>
							</Accordion.Item>
						</Accordion>
					)}
				</Modal>

				{/* ------------------- *** --------------- */}
				{/* Para publicar/despublicar itens em massa */}
				{/* ------------------- *** --------------- */}
				{showBatchPublishModal && (
					<BatchActionPublishModal
						selection={{
							disciplines,
							items,
							objects,
							objectsComposed,
						}}
						loading={false}
						nodes={locationList}
						onHide={() => setShowBatchPublishModal(false)}
						onSubmit={() => handleBatchConfirmation()}
						show={showBatchPublishModal}
						variant="confirm-modal-default"
						action={batchAction}
						onLocationSelect={setBatchToLocation}
						onStoreSelect={setBatchToStore}
					></BatchActionPublishModal>
				)}

				{/* ------------------- *** --------------- */}
				{/* Para inativação itens em massa */}
				{/* ------------------- *** --------------- */}
				{showInativateMaterialModal && (
					<BatchInactivateMaterialModal
						selection={{
							disciplines,
							items,
							objects,
							objectsComposed,
						}}
						nodes={locationList}
						show={showInativateMaterialModal}
						variant={"form-modal"}
						loading={false}
						onHide={() => setShowInativateMaterialModal(false)}
						onSubmit={() => handleBatchInativateConfirmation()}
					/>
				)}

				{/* ------------------- *** --------------- */}
				{/* Para inativação itens em massa */}
				{/* ------------------- *** --------------- */}
				{showDeleteMaterialModal && (
					<BatchDeleteMaterialModal
						selection={{
							disciplines,
							items,
							objects,
							objectsComposed,
						}}
						nodes={locationList}
						show={showDeleteMaterialModal}
						variant={"form-modal"}
						loading={false}
						onHide={() => setShowDeleteMaterialModal(false)}
						onSubmit={() => handleBatchDeleteConfirmation()}
					/>
				)}

				{/*  */}
				{/*  */}
				{/* Sidebar filtros */}
				<Sidebar
					visible={showFilterSidebar}
					onHide={() => setShowFilterSidebar(false)}
					position="right"
					blockScroll
					dismissable={false}
					className="p-sidebar-md"
				>
					<h4 className="sidebar-import-header">
						Filtros{" "}
						<MdFilterList
							className="ml-2"
							size="20"
						/>
					</h4>
					<hr className="mt-0" />
					<Row className="sidebar-import-content">
						<Col
							xs={12}
							className="mt-2 mb-3"
						>
							<MultiSelectFilter>
								<Form.Label>Tipos de Material</Form.Label>
								<Dropdown
									value={materialType}
									placeholder={translation(
										"manager.filters.product_type",
									)}
									className="multiselect-dropdown ds-select"
									options={materialTypeItems}
									onChange={(event: any) =>
										handleOnChange(event, "product_type")
									}
								/>
							</MultiSelectFilter>
						</Col>

						<Col
							xs={12}
							className="mt-2 mb-3"
						>
							<MultiSelectFilter>
								<Form.Label>Local</Form.Label>
								<MultiSelect
									value={materialPublishPlace}
									maxSelectedLabels={1}
									selectedItemsLabel={
										"{0} " +
										translation("filters.selectedLabel")
									}
									optionLabel="label"
									optionValue="value"
									placeholder={translation(
										"manager.filters.product_publish_place",
									)}
									className="multiselect-dropdown ds-select"
									options={materialPublishPlaceItems}
									onChange={(event: any) =>
										handleOnChange(
											event,
											"product_publish_place",
										)
									}
									filter
								/>
							</MultiSelectFilter>
						</Col>

						<Col
							xs={12}
							className="mb-3"
						>
							<MultiSelectFilter>
								<Form.Label>Tipo de objeto</Form.Label>
								<MultiSelect
									value={category}
									maxSelectedLabels={1}
									selectedItemsLabel={
										"{0} " +
										translation("filters.selectedLabel")
									}
									optionLabel="title"
									optionValue="id"
									placeholder={translation(
										"manager.filters.object_type",
									)}
									className="multiselect-dropdown ds-select"
									options={categoriesItems}
									onChange={(event: any) =>
										handleOnChange(event, "category_type")
									}
									filter
									itemTemplate={categoryTemplate}
								/>
							</MultiSelectFilter>
						</Col>

						<Col
							xs={12}
							className="mb-3"
						>
							<MultiSelectFilter>
								<Form.Label>Indicadores</Form.Label>
								<MultiSelect
									value={indicatorsFilter}
									maxSelectedLabels={1}
									selectedItemsLabel={
										"{0} " +
										translation("filters.selectedLabel")
									}
									optionLabel="title"
									optionValue="id"
									placeholder="Selecionar indicador"
									className="multiselect-dropdown ds-select"
									options={indicatorsFilterItems}
									onChange={(event: any) =>
										handleOnChange(event, "indicators")
									}
									filter
								/>
							</MultiSelectFilter>
						</Col>

						<Col
							xs={12}
							className="mt-2 mb-3"
						>
							<MultiSelectFilter>
								<Form.Label>Nível de formação</Form.Label>
								<MultiSelect
									value={filters.modalities}
									placeholder={`Selecionar nível`}
									className="multiselect-dropdown ds-select"
									options={modalities}
									onChange={(event: any) =>
										handleOnChange(event, "modalities")
									}
								/>
							</MultiSelectFilter>
						</Col>

						{user.is_superuser && (
							<Col
								xs={12}
								className="mb-3"
							>
								<MultiSelectFilter>
									<Form.Label>Parceiro</Form.Label>
									<MultiSelect
										scrollHeight="150px"
										value={partnersSelected}
										maxSelectedLabels={1}
										selectedItemsLabel={
											"{0} " +
											translation("filters.selectedLabel")
										}
										optionLabel="name"
										optionValue="id"
										placeholder="Selecionar parceiro"
										className="multiselect-dropdown ds-select"
										options={partnersOptions}
										onChange={(event: any) =>
											handleOnChange(event, "partners")
										}
										filter
									/>
								</MultiSelectFilter>
							</Col>
						)}

						<Col
							xs={12}
							className="mb-3"
						>
							<MultiSelectFilter>
								<Form.Label>Prazo</Form.Label>
								<MultiSelect
									scrollHeight="75px"
									value={deadlineFilter}
									maxSelectedLabels={1}
									selectedItemsLabel={
										"{0} " +
										translation("filters.selectedLabel")
									}
									optionLabel="title"
									optionValue="id"
									placeholder="Selecionar prazo"
									className="multiselect-dropdown ds-select"
									options={deadlineFilterItems}
									onChange={(event: any) =>
										handleOnChange(event, "deadlines")
									}
									filter
								/>
							</MultiSelectFilter>
						</Col>

						{projectFilterItems.length > 0 && (
							<Col
								xs={12}
								className="mb-3"
							>
								<MultiSelectFilter>
									<Form.Label>Projeto</Form.Label>
									<MultiSelect
										scrollHeight="75px"
										value={projectFilter}
										maxSelectedLabels={1}
										selectedItemsLabel={
											"{0} " +
											translation("filters.selectedLabel")
										}
										optionLabel="title"
										optionValue="id"
										placeholder="Selecionar projeto"
										className="multiselect-dropdown ds-select"
										options={projectFilterItems}
										onChange={(event: any) =>
											handleOnChange(event, "project")
										}
										filter
									/>
								</MultiSelectFilter>
							</Col>
						)}
					</Row>
					<Row>
						<div className="sidebar-import-footer">
							<div className="d-flex justify-content-between">
								<Button
									className="mt-3"
									variant="outline-primary"
									onClick={() => handleButtonClear()}
								>
									{translation("filters.clear")}
								</Button>
								<Button
									className="mt-3"
									variant="primary"
									onClick={() => handleApplyFilters()}
								>
									{translation("filters.apply")}
								</Button>
							</div>
						</div>
					</Row>
				</Sidebar>
			</Container>
		</>
	);
};
